<template>
    <highcharts
        class="chart h-100 min-height-300"
        :constructor-type="'chart'"
        :options="chartOptions"
    ></highcharts>
</template>
<script>
    export default {
        props: {
            connectionsData: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                chartOptions: {
                    chart: {
                        type: 'bar'
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: this.getCategoriesX()
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Instance database sizes'
                        }
                    },
                    legend: {
                        reversed: true
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal'
                        }
                    },
                    series: [{
                        name: 'DB size(MB)',
                        color: 'rgb(113,134,157)',
                        data: this.getSeries()
                    }]
                }
            }
        },
        methods: {
            getCategoriesX() {
                let a = [];
                this.connectionsData.forEach(el => {
                    a.push(el.instance);
                });
                return a;
            },
            getSeries() {
                let sizes = [];
                this.connectionsData.forEach(el => {
                    sizes.push(parseFloat(el.size));
                });

                return sizes;
            }
        }
    };
</script>
